var path = 'areas/environments/views/endpoints/generic_endpoint.html';
var html = "<div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/environments/views/endpoints/generic_endpoint.html
// module id = 8905647076144410
// module chunks = 1